import { Carousel } from 'antd'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import { routesPath } from '@api/home/utils'
import { useOpenSubpopwindow } from '@ui-pc/Subscription'
import { checkTopBannerSameImgUrl } from '@utils/index'

import styles from './index.module.scss'

import type { RootState } from '@api/home/store'
interface ICommonTopAdProps {}

const CommonTopAd: React.FunctionComponent<ICommonTopAdProps> = () => {
  const list = useSelector((state: RootState) => state.app.topAd)
  const [comUrl, setComUrl] = React.useState(null)
  const location = useLocation()

  useOpenSubpopwindow(
    [routesPath.cart, routesPath.checkout].includes(location.pathname as any)
  )

  React.useEffect(() => {
    if (list?.length) {
      // 判断背景图是不是都是一样的，如果是则背景图不要进行轮播效果，只让内容轮播
      const url = checkTopBannerSameImgUrl(list)
      setComUrl(url)
    }
  }, [list])

  const bgImgFun = (url: string) => {
    return {
      backgroundImage: `url(${url})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }
  }

  return (
    <>
      {list?.length ? (
        <div
          className={styles['topad-wrap']}
          style={comUrl ? { ...bgImgFun(comUrl) } : null}>
          <Carousel dots={false} autoplay autoplaySpeed={5000}>
            {list.map((item) => {
              const bgImg =
                item.navImg?.length > 0 ? item.navImg[0].navImg : null
              const bgColor = bgImg ? '' : item.backgroundColor
              let obj = {
                color: item.navColor
              }
              if (!comUrl) {
                Object.assign(obj, {
                  backgroundColor: bgColor,
                  ...bgImgFun(bgImg)
                })
              }
              return (
                <div key={item.id}>
                  <Link
                    to={item.url || location.pathname + location.search}
                    className={styles['topad']}
                    style={obj}>
                    <span
                      className={styles['topad-content']}
                      dangerouslySetInnerHTML={{
                        __html: item.navTitle
                      }}></span>
                  </Link>
                </div>
              )
            })}
          </Carousel>
        </div>
      ) : null}
    </>
  )
}

export default CommonTopAd
